import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

export interface TagFiltroAplicado {
  chave: string;
  texto: string;
}

@Component({
  selector: 'app-filtro-painel',
  standalone: true,
  imports: [MatIcon],
  templateUrl: './filtro-painel.component.html',
  styleUrl: './filtro-painel.component.css'
})
export class FiltroPainelComponent {
  @Input() aberto = false;
  @Input() tags: TagFiltroAplicado[] = [];
  @Input() visualizaFiltrosAplicados = true;

  @Output() removerTag = new EventEmitter<string>();
}
